"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var index_1 = require("./shared/index");
/**
 * Reporting combo box component is for reporting controls to draw paths and paths with mapped colors (if any exists).
 */
require("./reporting-combobox.component.css");
var ReportingComboboxComponent = /** @class */ (function () {
    function ReportingComboboxComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.showItemsLimit = 0;
        /**
         * Transfer selected value. It returns combo option which should have at least id and name.
         * @type {EventEmitter<any>}
         */
        this.valueChange = new core_1.EventEmitter();
        /**
         * Triggers when selection panel get closed
         * @type {EventEmitter}
         */
        this.onClose = new core_1.EventEmitter();
        this.processedData = [];
    }
    Object.defineProperty(ReportingComboboxComponent.prototype, "groupedData", {
        get: function () {
            return this._groupedData;
        },
        /**
         * Grouped data, which is path oriented, so it should contain groups of paths. For more see type of data.
         * This data can also contain paths with mapped colors.
         * @param data
         */
        set: function (data) {
            this._groupedData = data ? data : [];
            this.processedData = this.filterGroups('');
            this._selectedValue = this.findItem(this.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingComboboxComponent.prototype, "selectedValue", {
        get: function () {
            return this._selectedValue;
        },
        set: function (value) {
            this._selectedValue = value;
            this.valueChange.emit(this._selectedValue);
            // for reset mat-select selected value
            this._selectedValue = null;
        },
        enumerable: true,
        configurable: true
    });
    ReportingComboboxComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.select.open();
        this.changeDetectorRef.detectChanges();
        this.openedChangeSubscription = this.select.openedChange.asObservable().subscribe(function (opened) {
            opened && _this.searchInput.focus();
            !opened && _this.onClose.emit(true);
        });
    };
    ReportingComboboxComponent.prototype.ngOnDestroy = function () {
        if (this.openedChangeSubscription) {
            this.openedChangeSubscription.unsubscribe();
        }
    };
    ReportingComboboxComponent.prototype.displayFn = function (value) {
        return value && typeof value === 'object' ? value.name : value;
    };
    ReportingComboboxComponent.prototype.filterGroups = function (name) {
        var _this = this;
        var itemName = this.displayFn(name);
        itemName = itemName || '';
        return this.groupedData.map(function (group) {
            var groupLimitCounter = 0;
            return {
                name: group.name,
                items: group.items.filter(function (item) {
                    var ret = (!_this.showItemsLimit || groupLimitCounter < _this.showItemsLimit) && item.name.toLowerCase().indexOf(itemName.toLowerCase()) !== -1;
                    if (ret) {
                        groupLimitCounter++;
                    }
                    return ret;
                })
            };
        }).filter(function (group) {
            return group.items.length > 0;
        });
    };
    ReportingComboboxComponent.prototype.findItem = function (value) {
        var foundItem = this.processedData.find(function (group) {
            return group.items.find(function (item) {
                return item.value.id === value;
            });
        });
        return foundItem ? foundItem.items.find(function (item) {
            return item.value.id === value;
        }) : null;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ReportingComboboxComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ReportingComboboxComponent.prototype, "hasColor", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ReportingComboboxComponent.prototype, "placeHolder", void 0);
    __decorate([
        core_1.Input('value'),
        __metadata("design:type", Number)
    ], ReportingComboboxComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ReportingComboboxComponent.prototype, "showItemsLimit", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", index_1.ComboboxOptions),
        __metadata("design:paramtypes", [index_1.ComboboxOptions])
    ], ReportingComboboxComponent.prototype, "groupedData", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ReportingComboboxComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ReportingComboboxComponent.prototype, "onClose", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatSelect),
        __metadata("design:type", material_1.MatSelect)
    ], ReportingComboboxComponent.prototype, "select", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatInput),
        __metadata("design:type", material_1.MatInput)
    ], ReportingComboboxComponent.prototype, "searchInput", void 0);
    ReportingComboboxComponent = __decorate([
        core_1.Component({
            
            selector: "sis-reporting-combobox",
            template: require('./reporting-combobox.component.html')
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], ReportingComboboxComponent);
    return ReportingComboboxComponent;
}());
exports.ReportingComboboxComponent = ReportingComboboxComponent;
//# sourceMappingURL=reporting-combobox.component.js.map